import React from "react";
import "../styles/Footer.css";
export default function Footer() {
  return (
    <footer>
      <a
        href="https://www.linkedin.com/in/agnes-lee-041971189/"
        target="_blank"
        rel="noreferrer"
      >
        Agnes LinkdIn
      </a>
    </footer>
  );
}
